import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { FilePen, Gauge, TrendingUp } from "lucide-react";
import { stashTailor, tailorUrl } from "@/lib/tailor";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/Common";
import { AtsBadge } from "@/components/AtsBadge";
import { extractScore } from "@/components/ResultScore";
import { ToolRunner } from "@/pages/AIStudio";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, tierRank } from "@/lib/api";
import { recordScore, useAtsHistory, usePassMin } from "@/lib/atsScores";
import { findAts, loadTools } from "@/lib/tools";

export const AutoBoost = ({ job }) => {
  const { tier } = useAuth();
  const score = useAtsHistory(job.id).at(-1)?.score ?? null;
  const min = usePassMin();
  const [tool, setTool] = useState(null);
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => { loadTools().then((d) => { const t = findAts(d?.tools); if (t && tierRank(t.tier) <= tierRank(d?.tier || tier)) setTool(t); }); }, [tier]);
  if (!tool) return null;
  const check = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/ai/tools/${tool.id}`, { job_id: job.id, inputs: {} });
      const s = extractScore(data, true);
      if (s != null) recordScore(job.id, s, tool.id); else toast.error("Couldn't read a score from the check.");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      {score == null ? (
        <Button variant="outline" onClick={check} disabled={busy} className="border-[#D4AF37]/50 text-[#F3C649] hover:bg-[#D4AF37]/10" data-testid={`auto-check-ats-${job.id}`}>{busy ? <Spinner /> : <Gauge className="h-4 w-4" />}Check ATS score</Button>
      ) : score < min && (
        <Button variant="outline" onClick={() => setOpen(true)} className="border-[#D4AF37]/50 text-[#F3C649] hover:bg-[#D4AF37]/10" data-testid={`auto-boost-${job.id}`}><TrendingUp className="h-4 w-4" />Boost score</Button>
      )}
      <AtsBadge jobId={job.id} />
      <Link to={tailorUrl(job.id)} onClick={() => stashTailor({ jobId: job.id, job: { title: job.title, company: job.company }, ideas: [] })} className="inline-flex items-center gap-1 text-xs text-zinc-400 transition-colors hover:text-[#F3C649]" data-testid={`auto-edit-resume-${job.id}`}><FilePen className="h-3.5 w-3.5" />Edit resume</Link>
      {open && <ToolRunner tool={tool} initialJob={{ id: job.id, title: job.title, company: job.company }} onClose={() => setOpen(false)} />}
    </>
  );
};
